export function getSlidesPerView(
  desired: number,
  fallback: number,
  isMediaQuery: boolean
) {
  return isMediaQuery ? desired : fallback;
}
